(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeDetailController', PaynetModeDetailController);

    PaynetModeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PaynetMode'];

    function PaynetModeDetailController($scope, $rootScope, $stateParams, previousState, entity, PaynetMode) {
        var vm = this;

        vm.paynetMode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:paynetModeUpdate', function(event, result) {
            vm.paynetMode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
